/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: { // Mesmo valor usado nas configurações (defaultNS)
    menu: {
      examsTitle: 'Recordings',
      dicomTitle: 'Images',
      medicalReportsTitle: 'Medical Results',
      reportsTitle: 'Reports',
      customizationTitle: 'Customization',
      marketingTitle: 'Marketing',
      hooksFleuryTitle: 'Fleury Hooks',
      mp4ReprocessTitle: 'Reprocess MP4',
      communicationTitle: 'Communication hub',
      financialTitle: 'Financial area',
      storageTitle: 'Storage',
      goOutTitle: 'Logout',
      maternityBookletTitle: 'Maternity Booklet',
      learnMore: 'learn more',
      user: 'User',
      platform: 'Platform',
    },
    home: {
      noPeriodSelected: 'No period selected',
      notFoundData: 'Data not found.',
      errorLoadingData: 'An error occurred while loading the data.',
      tryAdmContact: 'Contact your administrator!',
      timeoutError: 'The request timeout was exceeded.',
    },

    appEnabled: {
      noData: 'Not enough data.',
      insufficient_data: "Insufficient data.",
      clear_filters_try_again: "Clear your filters and try again",
      v_baby_fleury: "V-Baby on your brand",
      active_brands: "Active Brands",
      units: "Units",
      installed_equipment: "Installed Equipment",
      previous_interval: "previous interval",
      curiosities: "Curiosities",
      top_5_content_watched: "Top 5 most watched content by the moms at your clinic:",
      most_popular_baby_name: "Do you know the most popular baby name out there?",
      other_popular_names: "Other names gaining popularity:",
      did_you_know_videos_podcasts: "Did you know? Your moms prefer videos and podcasts over articles.",
      data_not_found: "Insufficient data.",
      total_exams: 'Exams conducted',
      booking_clicks: 'Schedule clicks',
      exam_view_quantity: 'Exams views',
      baby_users_quantity: "Patients in the App",
      articles_read: "Articles read",
      videos_podcasts_watched: "Videos and podcasts watched",
      logo_share: 'Shared Brand ',
      vbabySharesByMoms: 'Number of times a video with a frame was saved or shared!',
      insights: 'Insights',
      reviews: 'Reviews',
      overview: 'Overview',
      share: 'Share',
      totalRatings: 'Total ratings',
      averageRatings: 'Average app rating',
      ratingsWithComments: 'Ratings with comments',
      noRatingsFound: 'No ratings found',
      
      superFeedbackTooltip: 'Super feedback',
      alertFeedbackTooltip: 'Alert signal',
      criticalFeedbackTooltip: 'Critical',

      vbabyContentsAccessedByMoms: 'Check out how many V-Baby informative contents were accessed by moms!',
      vbabyInformationalContentViews: 'V-Baby informational content views',

      vbabyExamsPatients: ' V-Baby Patients and Exams Conducted',

      vbabyDailyUsageAndExams: 'Find out how many moms are using the V-Baby app every day!',

      momsFeedbacks: "Moms' Feedbacks",

      week: 'week',

      topFiveContents: 'Top 5 contents watched by moms:',

      readMore: 'Read more',

      topMostWatchedContents: 'Top 5 contents watched by moms from your clinic:',
      momsPreferences: 'Did you know?',
      videosFavorites: 'Did you know? Moms prefer videos and podcasts over articles.',
      articlesFavorites: 'Did you know? Moms prefer articles over videos and podcasts.',
      articlesRead: ' articles read',
      videosWatched: ' videos and podcasts watched',

      appCuriositiesMomSuccess: 'The curiosities on the app are trending with your moms!',
      were: 'There were',
      sharings: '{{sharings}} shares',
      thisWeek: 'just this week!',

      mostFamousFrame: 'The most successful frame among the moms has been ',
      mostFamousFrameNotFounded: 'The most successful frame among the moms ',

      isTheOne: 'is the ',
      noFrameDataFounded: 'No frame data found!',

      mostFamousBabyName: 'Do you know the most popular baby name out there?',
      is: 'Is',
      vbabyTotalFamousName: 'We have {{value}} in total on V-Baby right now!',
      othersSuccessNames: 'Other popular names:',

      vbabyViewers: 'Your patients loved the live stream on V-Baby!',
      live: 'LIVE',
      quantityMomsParticipating: 'From {{organization}} alone, {{quantity}} moms were participating with us!',
      quantityMomParticipating: 'From {{organization}} alone, was 1 mom participating with us!'
    },

    appDisabled: {
      total_exams: 'Exams conducted',
      sharingClicks: 'Sharing clicks',
      exam_view_quantity: 'Exams views',
      baby_users_quantity: "Patients in the App",
      momsFeedbacks: "Moms' Feedbacks",
      score: 'Rate:',
      feedbackAt: '{{date}} at {{time}}'
    },

    notFoundedPage: 'Page not found!',
    goBack: 'Go back',

    components: {
      selectOrganization: 'Select an organization',
      filter: 'Filters',
      results: 'See results',
      refreshButton: 'Refresh',

      calendar: {
        thisMonth: 'This month',
        lastThirtyDays: 'Last 30 days',
        lastFifteenDays: 'Last 15 days',
        lastSevenDays: 'Last 7 days',
        today: 'Today',
        yesterday: 'Yesterday',
        to: 'to',
        clear: 'Clear',
        apply: 'Apply'
      },

      lineChart: {
        total_exams: 'Exams conducted',
        vbabyPatients: 'V-Baby patients',
        date: 'Date:',
        accessDate: 'Access/exam date',
        numberPatientsExams: 'Number of patients and exams',
      },

      pagination: {
        resultsPage: 'results per page',
        results: 'results',
        "page": "page",
        "of": "of"
      },

      "tabs": {
        "feedbacks": "Feedbacks",
        "ratings": "Reviews"
      },
      
      "ratings": {
        "averageRating": "Average app ratings"
      }
    },

    recap: {
      results: 'Check out your amazing results from 2024!',
      milestones: "We've gathered your milestones from this year with V-Baby.",
    },
    expiredToken: "Session expired. Redirecting to the login screen in 5 seconds."
  }
}
